import React, {useEffect, useMemo, useRef, useState} from 'react';

import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {toast} from "react-toastify";
import {collection, doc, getDoc, getDocs, query, updateDoc, where} from "firebase/firestore";
import {db, functions} from "../../utils/firebaseApp";
import {Button, CssBaseline, Stack, Toolbar, Typography} from "@mui/material";

import axios from "axios";
import {ArrowBackIosNew, ChevronRight} from '@mui/icons-material';
import Box from "@mui/material/Box";
import LoadingScreen from "../../components/shared-components/LoadingScreen";
import {useAtom, useAtomValue, useSetAtom} from "jotai";
import {AnswerAtom, AnswersAtom, PrefetchedImagesAtom, SurveyAtom, SurveyQuestionsAtom} from "./atoms";
import {SelectLanguage} from "./components/SelectLanguage";
import {v4 as uuid} from "uuid";
import {grey} from "@mui/material/colors";
import {Question} from "./components/Question";
import {enums} from "../../utils/enums";
import {confirm} from "react-confirm-box";
import {confirmDialogOptions} from "../../components/ConfirmDialog";
import {uploadFileInStorage, uploadPhoto, uploadVoice} from "../../utils/functions";
import {httpsCallable} from "firebase/functions";
import TouchRipple from "@mui/material/ButtonBase/TouchRipple";
import {LinearProgressWithLabel} from "../../components/shared-components/progress/LinearProgressWithLabel";
import {VoiceRecordingState} from "../create-project-page-new/atoms";
import {QUESTION_TYPES_FOR_LOGIC} from "../../utils/enums";
import {SurveyNotAvailable} from "./components/SurveyNotAvailable";
import {ThankYouPage} from "./components/thank-you-page";
import moment from "moment";
import LinearProgress from "@mui/material/LinearProgress";
import {QuestionTypes} from "../create-project-page-new/enums";

const SurveyPage = ({isPreview = false}) => {
  const buttonRef = useRef();
  const rippleRef = useRef();
  const [survey, setSurvey] = useAtom(SurveyAtom);
  const [answers, setAnswers] = useAtom(AnswersAtom);
  const [answer, setAnswer] = useAtom(AnswerAtom);
  const [questions, setQuestions] = useAtom(SurveyQuestionsAtom);
  const setImages = useSetAtom(PrefetchedImagesAtom);
  const navigate = useNavigate()
  const [questionIndex, setQuestionIndex] = useState(0)
  const [loading, setLoading] = useState(true)
  const [submitPercent, setSubmitPercent] = useState(0)
  const [submitMessage, setSubmitMessage] = useState("")
  const [showThankYouPage, setShowThankYouPage] = useState(false);
  const [ip, setIP] = useState(false)
  const [languages, setLanguages] = useState([])
  const [searchParams, setSearchParams] = useSearchParams();
  const isRecording = useAtomValue(VoiceRecordingState);
  const submitAnswer = httpsCallable(functions, "submitAnswer");
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.visualViewport) {
        setIsKeyboardOpen(window.innerHeight > window.visualViewport.height);
      }
    };

    window.visualViewport?.addEventListener("resize", handleResize);
    return () => {
      window.visualViewport?.removeEventListener("resize", handleResize);
    };
  }, []);

  // const searchParams = new URLSearchParams(window.location.search);
  let {uid} = useParams();
  // Extract the value of the 'token' parameter
  const token = searchParams.get('token');
  const languageBCP47 = searchParams.get('lang');

  useEffect(() => {
    if (!languageBCP47) {
      return;
    }
    let langQuestions = []
    if (languageBCP47) {
      langQuestions = questions
        ?.filter(question => question?.languageObject?.BCP47 === languageBCP47)
        ?.map(question => {
          const englishQuestion = questions?.find(item => item?.uid === (question?.originalReferenceUid || question?.uid));
          return {
            ...question,
            rules: englishQuestion?.rules || [],
            allOtherCasesQuestion: englishQuestion?.allOtherCasesQuestion || question?.allOtherCasesQuestion
          }
        })
        ?.sort((a, b) => a?.orderNumber - b?.orderNumber);
      console.log(langQuestions)
    }
    const images = {};
    if (survey?.thankYouPage && survey?.thankYouPage?.imgUrl) {
      const img = new Image();
      img.src = survey?.thankYouPage?.imgUrl;

      img.onload = () => console.log("Preloaded image: ", survey?.thankYouPage?.imgUrl);
      img.onerror = (error) => console.log("Failed to preload img: ", survey?.thankYouPage?.imgUrl, error);
      images[survey?.thankYouPage?.imgUrl] = img;
    }
    langQuestions?.forEach(i => {
      const images = [];
      if (i?.imgUrl) {
        images.push(i?.imgUrl)

      }
      if (i?.options && i?.options?.length) {
        for (const option of i?.options || []) {
          if (option?.imageUrl) {
            images.push(option?.imageUrl);
          }
        }
      }
      for (const imgUrl of images) {
        const img = new Image();
        img.src = imgUrl;

        img.onload = () => console.log("Preloaded image: ", imgUrl);
        img.onerror = (error) => console.log("Failed to preload img: ", imgUrl, error);
        images[imgUrl] = img;
      }
    })
    setImages(images);
    setAnswers(langQuestions?.length > 0 ? [langQuestions[0]] : []);
    setAnswer(langQuestions?.length > 0 ? langQuestions[0] : null);
    setQuestionIndex(0);
  }, [questions, token, languageBCP47])

  useEffect(() => {
    // TODO UROS check logic here I think i fixed this
    const answer = answers[questionIndex];
    const langQuestions = questions?.filter(question => question?.languageObject?.BCP47 === languageBCP47);
    const question = langQuestions?.find(i => i?.uid === answer?.questionUid || i?.originalReferenceUid === answer?.questionUid);
    console.log("Selected Question (by index)", question);
    setAnswer(question || answer || null);
  }, [answers, questionIndex, questions, languageBCP47])

  const addSearchParam = (key, value) => {
    // Create a new instance of searchParams to avoid mutation
    const newSearchParams = new URLSearchParams(searchParams);

    // Add or update the 'lang' param
    if (key) {
      newSearchParams.set(key, value);
      // Set the new search parameters
      setSearchParams(newSearchParams);
      console.log("search params", key, value)
    }
  };

  useEffect(() => {
    const checkToken = async () => {
      if (isPreview) {
        toast.info("You are currently in preview survey mode.");
        return;
      }
      if (token) {
        const tokensRef = doc(db, "tokens", token);
        const tokenDoc = await getDoc(tokensRef);
        console.log(tokenDoc?.data())
        if (!tokenDoc.exists()) navigate('/not-available')
        if (tokenDoc.data().used) navigate('/thankyou')
      } else {
        const q = query(collection(db, "tokens"), where("surveyUid", "==", uid));
        const querySnapshot = await getDocs(q);
        if (!querySnapshot.empty) {
          toast.info("This survey is protected and can only be accessed with a valid token.")
          navigate('/not-available')
        }
      }
    }
    const fetchSurvey = async () => {
      try {
        setLoading(true);
        const surveyRef = doc(db, "surveys", uid);
        const surveyDocSnap = await getDoc(surveyRef);
        if (!surveyDocSnap.exists()) navigate('/not-available')
        const surveyDoc = surveyDocSnap.data();
        const languages = surveyDoc?.languages || []

        setSurvey(surveyDoc);
        setLanguages(languages)
        console.log(surveyDoc)

        const q = query(collection(db, "questions"), where("surveyUid", "==", uid));
        const querySnapshot = await getDocs(q);
        const questionsData = []
        const respondentUid = token || uuid();

        querySnapshot.forEach((doc) => {
          const question = {...doc.data()}
          questionsData.push({
            ...question,
            token: token || "",
            questionUid: question?.originalReferenceUid || question?.uid,
            uid: uuid(),
            respondentUid
          })
        });

        setQuestions(questionsData);
        setAnswers([]);
        if (!searchParams.get('lang') && languages?.length === 1) {
          addSearchParam("lang", languages[0]?.BCP47)
        }
      } catch (error) {
        setAnswers([]);
        setQuestions([]);
        setLanguages([]);
        toast.error(error?.message || "Something failed...");
        navigate("/");
      } finally {
        setLoading(false);
      }
    }

    if (uid) {
      checkToken()
      fetchSurvey();
      getIpData();
    }
  }, [uid, isPreview, token])

  async function sendAnswerObjectToBackend(answerObject) {
    console.log(answerObject)
    switch (answerObject.type) {
      case QuestionTypes.IMAGE:
        const photos = [];
        for (const photoUri of answerObject?.photos || []) {
          try {
            const photo = await uploadPhoto(photoUri);
            if (photo) {
              photos.push(photo);
            }
          } catch (error) {
            console.log(error);
            toast.error("Failed to upload photo")
          }
        }
        answerObject.photos = photos
        break;
      case QuestionTypes.FILE_UPLOAD:
        const files = [];
        for (const file of answerObject?.files || []) {
          try {
            const fileUrl = await uploadFileInStorage(file);
            if (fileUrl) {
              files.push({uid: uuid(), url: fileUrl, size: file?.size, name: file?.name, type: file?.type});
            }
          } catch (error) {
            console.log(error);
            toast.error("Failed to upload photo")
          }
        }
        answerObject.files = files
        break;
      case QuestionTypes.VOICE:
        if (answerObject?.voiceBase64) {
          if (survey.saveAudioRecordings) {
            try {
              answerObject.voiceUrl = await uploadVoice(answerObject.voiceBase64)
            } catch (error) {
              console.log(error);
            }
          }
          answerObject.voiceBase64 = answerObject?.voiceBase64.substr(answerObject?.voiceBase64.indexOf(",") + 1);
        }
        break;
    }

    answerObject.ipAddress = ip
    console.log("submitting answer", answerObject)
    return submitAnswer(answerObject)
  }

  // This function animates the click effect for the button, similar to a submit button animation,
  // whenever a user selects an option from multiple choices or provides a location.
  const animateClickButton = () => {
    if (buttonRef.current && rippleRef.current) {
      const container = buttonRef.current;
      const rect = container.getBoundingClientRect();
      rippleRef.current?.start(
        {
          clientX: rect.left + rect.width / 2,
          clientY: rect.top + rect.height / 2,
        },
        // when center is true, the ripple doesn't travel to the border of the container
        {center: false},
      );
      buttonRef.current.style.transform = "scale(1.05)";

      setTimeout(() => {
        rippleRef.current?.stop({})
        buttonRef.current.style.transform = "scale(1)";
      }, 320);
    }
  }

  const handleNext = () => {
    let langQuestions = [];
    if (languageBCP47) {
      langQuestions = questions
        ?.filter(question => question?.languageObject?.BCP47 === "en-US")
        ?.sort((a, b) => a?.orderNumber - b?.orderNumber);
    }

    const otherCaseQuestion = langQuestions?.find(i => i?.orderNumber === answer?.allOtherCasesQuestion);
    let nextQuestionOrderNumber = otherCaseQuestion?.orderNumber;
    console.log("OTHER CASES", otherCaseQuestion, nextQuestionOrderNumber)
    console.log("questions", questions)
    console.log("answer", answer)
    const answerToUseForRules = questions.find(q =>
      q.languageObject?.BCP47 === "en-US" &&
      (q.questionUid === answer.originalReferenceUid || q.questionUid === answer.questionUid)
    );
    console.log("answerToUseForRules", answerToUseForRules)
    console.log("answer", answer)
    if (QUESTION_TYPES_FOR_LOGIC.includes(answerToUseForRules?.type) && answerToUseForRules?.rules?.length > 0) {
      let selectedOption;
      console.log("rules check", answer)
      selectedOption = answer.options.find(opt => opt.checked);
      console.log("selected option", selectedOption)
      console.log("answer rules", answerToUseForRules.rules)
      if (selectedOption) {
        const matchingRule = answerToUseForRules.rules.find(rule => rule.answerOption === selectedOption.uid);
        console.log("matching rule", matchingRule)
        if (matchingRule?.nextQuestion) {
          const nextQuestion = langQuestions.find(q => q.orderNumber === matchingRule.nextQuestion);
          nextQuestionOrderNumber = nextQuestion?.orderNumber || nextQuestionOrderNumber;
        }
      }
    }

    // Find the current answer index
    const previousAnswer = answers[questionIndex];

    if (questionIndex < answers.length - 1 && previousAnswer?.text === answer?.text) {
      // If this is not the last question and answer.text didn't change, go to the next question by index
      // setAnswer(answers[questionIndex + 1]);
      setQuestionIndex(prevIndex => prevIndex + 1);
      console.log("GO TO NEXT", previousAnswer, answer)
    } else if (previousAnswer?.text !== answer?.text || questionIndex === answers.length - 1) {
      // If the answer has changed or this is the last answer, move to nextQuestionUid if available
      const nextQuestion = langQuestions.find(item => item?.orderNumber === nextQuestionOrderNumber);
      console.log("NEXT", nextQuestion)
      if (nextQuestion) {
        const updatedAnswers = [...answers.slice(0, questionIndex), answer, nextQuestion]; // Keep answers up to current
        setAnswers(updatedAnswers); // Update answers list
        // setAnswer(nextQuestion);
        setQuestionIndex(prevIndex => prevIndex + 1);
      }
    }
  };

  const handleSubmit = async (delay = 0) => {
    saveAnswer();
    animateClickButton();

    if (delay > 0) {
      await new Promise(resolve => setTimeout(resolve, delay));
    }
    if (!!answer?.allOtherCasesQuestion) {
      // TODO IF THERE IS SOME NEXT QUESTION THEN GO TO NEXT
      handleNext();
      return;
    } else {
      const response = await confirm({
        title: `Are you sure you want to submit your answers?`
      }, confirmDialogOptions);
      if (response) {
        setAnswer(null);
        if (isPreview) {
          toast.info("Since this is a preview survey, your submitted answers will not be saved in the database.");
          navigate(`/create-survey/${survey?.uid}`);
          return;
        }
        const timestamp = new Date().getTime()
        const submittingAnswers = [...answers]?.map(answer => ({...answer, timestamp: timestamp}));
        if (submittingAnswers[questionIndex]) {
          submittingAnswers[questionIndex] = {...answer, timestamp: timestamp, submitted: true};
        }
        setLoading(true);
        let error = false;
        let index = 0;
        for (const submittingAnswer of submittingAnswers) {
          try {
            setSubmitMessage("Submitting your answers...")
            index = index + 1;
            setSubmitPercent(((index / (submittingAnswers?.length)) * 100) || 0);
            await sendAnswerObjectToBackend(submittingAnswer);
          } catch (e) {
            console.log(e);
            error = true;
            setSubmitMessage(`Failed to submit answer "${submittingAnswer?.question}"`)
          }
        }
        setSubmitMessage("Survey submission completed successfully.")

        if (token) {
          try {
            const tokensRef = doc(db, "tokens", token);
            await updateDoc(tokensRef, {used: true});
          } catch (error) {
            console.log(error);
          }
        }
        if (survey?.thankYouPage && survey?.thankYouPage?.question[languageBCP47]) {
          console.log("thank you page", survey?.thankYouPage)
          setShowThankYouPage(true);
        } else {
          navigate("/thankyou", {replace: true})
        }
        setLoading(false);
        setSubmitPercent(0);
        setSubmitMessage("");
      }
      return;
    }
  }

  const onSubmit = async (e) => {
    e?.preventDefault();
    handleSubmit();
  }

  const saveAnswer = () => {
    if (answer && answers[questionIndex]) {
      setAnswers(prev => {
        const state = [...prev];
        state[questionIndex] = {...answer, submitted: true};
        return state;
      })
    }
  }

  const getIpData = async () => {
    const res = await axios.get("https://api.ipify.org/?format=json");
    try {
      const ipDetails = await axios.get(`https://api.ipgeolocation.io/ipgeo?apiKey=ac9c0f52f42c4ad18160a3329030eef2&ip=${res.data.ip}&fields=geo`)
      setIP(ipDetails.data)
    } catch (error) {
      console.log(error);
    }
  };

  const canSubmit = useMemo(() => {
    if (!answer?.required) {
      return true;
    }
    let isValid = true;
    switch (answer?.type) {
      case QuestionTypes.IMAGE:
        console.log("image is valid:", !!answer?.photos && answer?.photos?.length > 0 && answer?.photos?.length <= 3)
        isValid = !!answer?.photos && answer?.photos?.length > 0 && answer?.photos?.length <= 3;
        break;
      case QuestionTypes.TEXT:
        isValid = !!answer?.text;
        break;
      case QuestionTypes.SLIDER:
        isValid = !!answer?.text;
        break;
      case QuestionTypes.VOICE:
        isValid = !!answer?.text || (!!answer?.voiceBase64 && answer?.audioDuration && answer?.audioDuration > 0 && answer?.audioDuration < 60);
        break;
      case QuestionTypes.MULTICHOICE:
        isValid = !!answer?.text && answer?.options?.filter(i => i?.checked)?.length > 0;
        break;
      case QuestionTypes.CHECKBOXES:
        isValid = !!answer?.text && answer?.options?.filter(i => i?.checked)?.length > 0;
        break;
      case QuestionTypes.DROPDOWN:
        isValid = !!answer?.text && answer?.options?.filter(i => i?.checked)?.length > 0;
        break;
      case QuestionTypes.MAPINPUT:
        isValid = answer?.pois && answer?.pois?.length > 0;
        break;
      case QuestionTypes.SECTION:
        isValid = true;
        break;
      case QuestionTypes.LOCATE_USER:
        isValid = !!answer?.text && !!answer?.lng && !!answer?.lat;
        break;
      case QuestionTypes.IMAGE_GALLERY:
        isValid = !!answer?.text && !!answer?.options?.filter(i => i?.checked)?.length > 0;
        break;
      case QuestionTypes.FILE_UPLOAD:
        isValid = answer?.files?.length > 0;
        break;
      default:
        isValid = true;
        break;
    }

    return isValid;
  }, [answer])

  const isDateValid = useMemo(() => {
    const isCurrentTimeInRange = (start, end, userTimezone) => {
      const currentTime = moment.tz(userTimezone); // Current time in user's timezone

      // If both start and end are null, return true
      if (start === null && end === null) {
        return true;
      }

      // If start is null, only check the current time against the end time
      if (start === null) {
        const endTime = moment(end); // Treat as local time, no timezone conversion
        return currentTime.isBefore(endTime);
      }

      // If end is null, only check the current time against the start time
      if (end === null) {
        const startTime = moment(start); // Treat as local time, no timezone conversion
        return currentTime.isAfter(startTime);
      }

      // If both start and end are present, check if the current time is between them
      const startTime = moment(start); // Treat as local time, no timezone conversion
      const endTime = moment(end); // Treat as local time, no timezone conversion
      return currentTime.isBetween(startTime, endTime, null, '[]'); // '[]' means inclusive of both start and end
    };

    return isCurrentTimeInRange(survey?.start, survey?.end, survey?.timezone);
  }, [survey?.start, survey?.end, survey?.timezone]);

  const progress = useMemo(() => {
    // Step 1: Find the largest orderNumber in questions
    const maxOrderNumber = questions?.filter(question => question?.languageObject?.BCP47 === languageBCP47)?.length - 1 || 1;

    // Step 2: Find the current orderNumber in the answer (assuming answer contains an orderNumber)
    const currentOrderNumber = answer?.orderNumber || 0;

    // Step 3: Calculate progress as a percentage (current / max orderNumber)
    return maxOrderNumber > 0 ? ((currentOrderNumber / maxOrderNumber) * 100) || 0 : 0;
  }, [answer, questions, languageBCP47]);

  return (
    isDateValid ? <Stack
        direction={"column"}
        justifyContent={'space-between'}
        component={"form"}
        onSubmit={onSubmit}
        sx={{
          maxWidth: '750px',
          width: "100%",
          height: "100%",
          px: 2, py: 4,
          mx: 'auto',
        }}>
        <CssBaseline/>
        <SelectLanguage
          languages={languages}
          selectedLanguage={languageBCP47}
          onSelect={(lang) => addSearchParam("lang", lang)}
        />
        <Box sx={{position: "absolute", top: 0, left: 0, right: 0}}>
          <LinearProgress
            value={progress} variant={"determinate"}
          />
        </Box>

        {loading &&
          <Box sx={{
            position: "absolute",
            inset: 0,
            bgcolor: "background.paper",
            zIndex: 1000
          }}>
            <LoadingScreen/>
            {submitPercent > 0 ? (
              <Box maxWidth={"sm"} sx={{mx: 'auto', width: "90%"}}>
                <LinearProgressWithLabel
                  value={submitPercent}
                />
                <Typography align={"center"} color={"#858585"} fontWeight={500}
                            variant={"h5"}>{submitMessage}</Typography>
              </Box>
            ) : null}
          </Box>}
        {showThankYouPage &&
          <ThankYouPage survey={survey} thankYouPage={survey?.thankYouPage} languageBCP47={languageBCP47}/>}

        {/*QUESTION VIEW COMPONENT*/}
        {languageBCP47 && <Question/>}

        {/*FOOTER BUTTONS*/}
        <Toolbar/>
        <Toolbar
          sx={{
            position: "fixed",
            bottom: 0,
            top: isKeyboardOpen ? "calc(50% - 100px)" : undefined,
            left: 0,
            right: 0,
            maxWidth: "md",
            mx: "auto",
            bgcolor: "background.paper"
          }}>
          <Stack direction={"row"} maxWidth={"sm"}
                 sx={{width: "100%", pb: 4, mx: 'auto', mb: "auto", pt: 0.5, px: 2, bgcolor: "background.paper"}}
                 justifyContent={"space-between"}
                 alignContent={"center"}
                 gap={2}>
            <Button variant={"contained"} id={"back-survey"}
                    disabled={questionIndex <= 0 || isRecording}
                    sx={{
                      bgcolor: grey[300],
                      borderRadius: 2,
                      boxShadow: 0,
                      p: "12px 20px",
                      '&:hover': {bgcolor: grey[200], boxShadow: 0}
                    }}
                    onClick={() => {
                      saveAnswer();
                      setQuestionIndex(questionIndex - 1);
                    }}>
              <ArrowBackIosNew/>
            </Button>
            <Button
              type={"submit"} className={"gradient-btn"}
              id={"submit-survey"}
              endIcon={<ChevronRight/>}
              sx={{flex: 1, p: "12px 20px", transition: "transform 0.2s ease-in-out", display: "relative"}}
              disabled={!canSubmit || loading || isRecording}
              disableRipple
              ref={buttonRef}
            >
              {!!answer?.allOtherCasesQuestion ? "Continue" : "Submit"}
              <TouchRipple ref={rippleRef} center/>
            </Button>
          </Stack>
        </Toolbar>
      </Stack> :
      <SurveyNotAvailable/>
  );
}


export default SurveyPage;

